module.exports = "/_next/static/images/OptimizeTheFirstTimeUserExperience@2x-96f883a7e4a20ebe49983df74c9dea8d.webp";